export default `/* Ids Link List Component */
.ids-link-list {
  list-style: none;
  margin-top: var(--ids-link-list-top-margin);
}

::slotted(*) {
  display: list-item;
  margin-bottom: var(--ids-link-list-item-margin);
  font-weight: var(--ids-font-weight-semi-bold);
}

ids-text {
  color: var(--ids-link-list-title-color-text-default);
  margin-bottom: var(--ids-link-list-title-bottom-margin);
  display: block;
}
ids-text:empty {
  margin-bottom: 0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtaHlwZXJsaW5rIiwic291cmNlcyI6WyJpZHMtbGluay1saXN0LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7QUFDQTtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLyogSWRzIExpbmsgTGlzdCBDb21wb25lbnQgKi9cbi5pZHMtbGluay1saXN0IHtcbiAgbGlzdC1zdHlsZTogbm9uZTtcbiAgbWFyZ2luLXRvcDogdmFyKC0taWRzLWxpbmstbGlzdC10b3AtbWFyZ2luKTtcbn1cblxuOjpzbG90dGVkKCopIHtcbiAgZGlzcGxheTogbGlzdC1pdGVtO1xuICBtYXJnaW4tYm90dG9tOiB2YXIoLS1pZHMtbGluay1saXN0LWl0ZW0tbWFyZ2luKTtcbiAgZm9udC13ZWlnaHQ6IHZhcigtLWlkcy1mb250LXdlaWdodC1zZW1pLWJvbGQpO1xufVxuXG5pZHMtdGV4dCB7XG4gIGNvbG9yOiB2YXIoLS1pZHMtbGluay1saXN0LXRpdGxlLWNvbG9yLXRleHQtZGVmYXVsdCk7XG4gIG1hcmdpbi1ib3R0b206IHZhcigtLWlkcy1saW5rLWxpc3QtdGl0bGUtYm90dG9tLW1hcmdpbik7XG4gIGRpc3BsYXk6IGJsb2NrO1xuXG4gICY6ZW1wdHkge1xuICAgIG1hcmdpbi1ib3R0b206IDA7XG4gIH1cbn1cbiJdfQ== */`;
